export default "__VITE_ASSET__Ck6n5cCV__"